<template>
  <div class="n-select" :class="{'small': small}">
    <label v-if="title">{{ title }}</label>
    <v-select
      v-if="!text" v-model="s_value" :multiple="Array.isArray(value)" :searchable="!readonly"
      :options="data" :label="label" :class="{'danger': !!danger}" :placeholder="placeholder" @input="update()">
      <template #open-indicator="{ attributes }">
        <img class="main-indicator" v-bind="attributes" :src="imgOpen" alt="">
      </template>
      <template #clear-selected="{ attributes }">
        <img class="main-indicator" v-bind="attributes" :src="imgOpen" alt="">
      </template>
      <template #option="option">
        <div v-if="withRadio" class="option-with-icon">
          <radio-icon />
          <span>{{ option[label] }}</span>
        </div>
        <span v-else>{{ option[label] }}</span>
      </template>
    </v-select>
    <div v-else class="text-place">
      <div v-if="!Array.isArray(value) && !!value">{{ value[label] }}</div>
      <div v-else-if="Array.isArray(value)">
        <span
          v-for="(v, i) in value"
          :key="i">{{ v[label] ? (v[label] + (value.length > 1 ? (i < value.length - 1 ? ', ' : '') : ''))
            : (v + (value.length > 1 ? (i < value.length - 1 ? ', ' : '') : '')) }}</span>
      </div>
      <div v-else>
        {{ placeholder }}
      </div>
    </div>
    <div v-if="danger && !noDanger" class="danger-text">
      {{ danger }}
    </div>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import imgOpen from 'assets/new/arrow-icon.svg'
import RadioIcon from '../Select/default/radio-icon.vue'

export default {
  name: 'NSelect',
  components: { RadioIcon, },
  props: {
    value: { default: '', },
    text: { default: false, type: Boolean, },
    readonly: { default: false, type: Boolean, },
    title: { type: String, default: '', },
    placeholder: { type: String, default: '', },
    danger: { type: String, default: '', },
    data: { type: Array, default: () => [], },
    label: { type: String, default: 'title', },
    small: { type: Boolean, default: false, },
    noDanger: { type: Boolean, default: false, },
    withRadio: { type: Boolean, default: false, },
    'update:value': {
      type: Function, default: () => {
      },
    },
  },
  data() {
    return {
      imgOpen,
      s_value: this.value,
    }
  },
  watch: {
    value() {
      this.s_value = this.value
    },
  },
  methods: {
    update() {
      this.$emit('change', this.s_value)
      this['update:value'](this.s_value)
      this.$emit('update:value', this.s_value)
      this.$emit('select', this.s_value)
    },
  },
}
</script>

<style lang="scss" scoped>

.danger-text {
  color: red;
  font-size: 13px;
}

:deep() {
  .vs__search {
    color: #757575;
  }

  .vs__dropdown-option--selected {
    .radio-icon {
      .inner-circle {
        background: var(--primary);
      }
    }
  }
}

.n-select {
  .option-with-icon {
    display: flex;
    align-items: center;

    .radio-icon {
      margin-right: 10px;
    }
  }

  .main-indicator {
    width: 18px;
    height: 18px;
  }

  min-width: 220px;

  &.small {
    min-width: 20px;

    :deep() {
      .vs__actions {
        display: none;
      }

      .vs__dropdown-menu {
      }
    }
  }

  :deep() {
    .v-select {
      &.danger {
        .vs__dropdown-toggle {
          border: 1px solid red;
        }

        .vs__actions {
          .vs__open-indicator {
            fill: red;
          }
        }
      }
    }
  }

  :deep(.vs__clear) {
    display: none;
  }

  :deep() {
    .vs__selected {
      background-color: #FFFFFF;
    }

    .vs__dropdown-option {
      white-space: normal !important;
    }

    .vs__dropdown-menu {
      min-width: 100px;
    }
  }

  :deep(.vs__dropdown-toggle) {
    border: 1px solid var(--border-color);
  }

  label {
    display: block;
    color: inherit;
    width: 100%;
    font-size: 1em;
    line-height: 1.2;
    text-align: left;
    padding: 6px 0;
  }

  .text-place {
    background-color: #FFFFFF;
    border-radius: var(--border-radius);
    padding: 9px 15px;
    display: flex;
    align-items: center;
    overflow: auto;
  }

  .v-select {
    //background-color: var(--default);
    border-radius: var(--border-radius);

    .vs__dropdown-toggle {
      border: 1px solid var(--border-color);
      padding: 8px 8px 9px;
    }

    .vs__dropdown-menu {
      background-color: var(--default);
    }
  }

  label {
    font-size: 1.1em;
    font-weight: bold;
    padding-bottom: 12px;

  }
  :deep() {
    .v-select {
      &.vs--multiple {
        .vs__selected-options {
          padding: 0 2px;
        }
        .vs__deselect {
          fill: var(--primary);
        }
        .vs__selected {
          padding: 0 5px;
          border-radius: 8px;
          border: 1px solid var(--primary);
        }
      }
    }
  }
}
</style>
